/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_AttachInputs */



/**
* | output |
* | --- |
* | "Attach a file" |
*
* @param {Chat_AttachInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_attach = /** @type {((inputs?: Chat_AttachInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_AttachInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Bestand toevoegen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Joindre un fichier")
	return /** @type {LocalizedString} */ ("Attach a file")
});